<template>
	<v-dialog
		v-model="dialog"
		max-width="700px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				:text="text"
				:color="text ? 'white' : 'secondary'"
				class="ml-2"
				@click.stop="dialog = true"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon class="mr-2">mdi-magnify</v-icon>
				検索
			</v-btn>
		</template>

		<v-card :tile="$vuetify.breakpoint.xs">
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">SampleSearchPage.vue</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>

			<v-form class="pa-2" ref="form" lazy-validation>
				<v-text-field
					:label="allRequired ? 'テキスト(必須)' : 'テキスト'"
					dense
					outlined
					:rules="allRequired ? [rules.required] : []"
					class="mt-4"
					hint="ここにヒントを表示"
				/>
				<v-select
					:label="allRequired ? 'セレクト(必須)' : 'セレクト'"
					:items="items"
					item-text="name"
					item-value="id"
					:rules="allRequired ? [rules.required] : []"
					hint="ここにヒントを表示"
					no-data-text="ここにデータがない時の文章"
					class="mt-4"
					outlined
					dense
				/>
				<v-select
					:label="allRequired ? 'マルチセレクト(必須)' : 'マルチセレクト'"
					:items="items"
					item-text="name"
					item-value="id"
					:rules="allRequired ? [rules.required] : []"
					hint="ここにヒントを表示"
					no-data-text="ここにデータがない時の文章"
					class="mt-4"
					multiple
					outlined
					dense
				/>
				<v-select
					:label="allRequired ? 'チップ表示 マルチセレクト(必須)' : 'チップ表示 マルチセレクト'"
					:items="items"
					item-text="name"
					item-value="id"
					:rules="allRequired ? [rules.required] : []"
					hint="ここにヒントを表示"
					no-data-text="ここにデータがない時の文章"
					class="mt-4"
					multiple
					outlined
					chips
					small-chips
					dense
				/>
				<v-combobox
					:label="allRequired ? 'コンボボックス(必須)' : 'コンボボックス'"
					:items="items"
					item-text="name"
					item-value="id"
					:rules="allRequired ? [rules.required] : []"
					hint="ここにヒントを表示"
					no-data-text="ここにデータがない時の文章"
					class="mt-4"
					outlined
					dense
				/>
				<div class="mt-4">
					<label class="text-body-2 font-weight-bold">{{
						allRequired ? "ラジオボタン(必須)" : "ラジオボタン"
					}}</label>
					<v-radio-group
						class="mt-1"
						row
						:rules="allRequired ? [rules.required] : []"
						hint="ここにヒントを表示"
					>
						<v-radio
							v-for="item in items"
							:label="item.name"
							:key="item.id"
							:value="item.id"
							class="mr-2"
							dense
						/>
					</v-radio-group>
				</div>

				<div class="mt-4">
					<label class="text-body-2 font-weight-bold">{{
						allRequired ? "チェックボックス(必須)" : "チェックボックス"
					}}</label>
					<v-row no-gutters class="mt-1 checkbox-wrapper">
						<v-checkbox
							v-model="multi"
							v-for="(item, i) in items"
							:label="item.name"
							:key="item.id"
							:value="item.id"
							:rules="allRequired ? [rules.required] : []"
							:hide-details="i != 0"
							class="mr-2"
							dense
						/>
					</v-row>
				</div>

				<div class="mt-4">
					<label class="text-body-2 font-weight-bold">{{ allRequired ? "日付(必須)" : "日付" }}</label>
					<v-row class="mt-2" no-gutters>
						<v-col class="pr-1" sm="4">
							<v-select dense outlined :items="years" :rules="allRequired ? [rules.required] : []">
								<template v-slot:append-outer>年</template>
							</v-select>
						</v-col>
						<v-col class="px-1" sm="4">
							<v-select dense outlined :items="months" :rules="allRequired ? [rules.required] : []">
								<template v-slot:append-outer>月</template>
							</v-select>
						</v-col>
						<v-col class="pl-1" sm="4">
							<v-select dense outlined :items="days" :rules="allRequired ? [rules.required] : []">
								<template v-slot:append-outer>日</template>
							</v-select>
						</v-col>
					</v-row>
				</div>

				<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							class="mt-4"
							:label="allRequired ? '日付(必須)' : '日付'"
							required
							readonly
							outlined
							dense
							:rules="allRequired ? [rules.required] : []"
							v-bind="attrs"
							v-on="on"
							hint="ここにヒントを表示"
						/>
					</template>
					<v-date-picker no-title locale="ja-JP" />
				</v-menu>

				<v-text-field
					:label="allRequired ? '時間(必須)' : '時間'"
					type="time"
					dense
					outlined
					:rules="allRequired ? [rules.required] : []"
					class="mt-4"
					hint="ここにヒントを表示"
				/>

				<div class="mt-4">
					<label class="text-body-2 font-weight-bold">{{ allRequired ? "日時(必須)" : "日時" }}</label>
					<v-row class="mt-2" no-gutters>
						<v-col cols="12">
							<v-row no-gutters>
								<v-col class="pr-1" cols="4">
									<v-select
										dense
										outlined
										:items="years"
										:rules="allRequired ? [rules.required] : []"
									>
										<template v-slot:append-outer>年</template>
									</v-select>
								</v-col>
								<v-col class="px-1" cols="4">
									<v-select
										dense
										outlined
										:items="months"
										:rules="allRequired ? [rules.required] : []"
									>
										<template v-slot:append-outer>月</template>
									</v-select>
								</v-col>
								<v-col class="pl-1" cols="4">
									<v-select
										dense
										outlined
										:items="days"
										:rules="allRequired ? [rules.required] : []"
									>
										<template v-slot:append-outer>日</template>
									</v-select>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12">
							<v-row no-gutters>
								<v-col class="pr-1" cols="4">
									<v-select
										dense
										outlined
										:items="hours"
										:rules="allRequired ? [rules.required] : []"
									>
										<template v-slot:append-outer>時</template>
									</v-select>
								</v-col>
								<v-col class="px-1" cols="4">
									<v-select
										dense
										outlined
										:items="minutes"
										:rules="allRequired ? [rules.required] : []"
									>
										<template v-slot:append-outer>分</template>
									</v-select>
								</v-col>
								<v-col class="pl-1" cols="4">
									<v-select
										dense
										outlined
										:items="seconds"
										:rules="allRequired ? [rules.required] : []"
									>
										<template v-slot:append-outer>秒</template>
									</v-select>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</div>

				<v-textarea
					class="mt-4"
					:label="allRequired ? 'テキストエリア(必須)' : 'テキストエリア'"
					:rules="allRequired ? [rules.required] : []"
					hint="ここにヒントを表示"
					outlined
					dense
				/>
			</v-form>
			<v-card-actions>
				<v-row no-gutters class="pb-2">
					<v-col cols="4" />
					<v-col cols="4">
						<v-row no-gutters justify="center">
							<v-btn color="secondary" @click="validateForm">
								<v-icon class="mr-1">mdi-magnify</v-icon>
								検索する
							</v-btn>
						</v-row>
					</v-col>
					<v-col cols="4">
						<v-row no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="dialog = false"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import rules from "../../../helper/rules"

export default {
	props: {
		text: Boolean,
	},
	data() {
		return {
			rules: rules,
			multi: [],
			dialog: false,
			allRequired: false,
		}
	},
	methods: {
		validateForm() {
			this.$refs.form.validate()
		},
	},
	computed: {
		items() {
			const array = []
			for (let i = 0; i < 5; i++) {
				array.push({ id: i, name: `項目${i}` })
			}
			return array
		},
		years() {
			const thisYear = new Date().getFullYear()
			const endYear = 1900
			const years = [...Array(thisYear - endYear + 1)].map((_, i) => thisYear - i)
			return years
		},
		months() {
			const months = [...Array(12)].map((_, i) => i + 1)
			return months
		},
		days() {
			const days = [...Array(31)].map((_, i) => i + 1)
			return days
		},
		hours() {
			const hours = [...Array(24)].map((_, i) => i)
			return hours
		},
		minutes() {
			const days = [...Array(60)].map((_, i) => i)
			return days
		},
		seconds() {
			const days = [...Array(60)].map((_, i) => i)
			return days
		},
	},
}
</script>